import React from "react"

import { makeStyles } from "@material-ui/core/styles"
import { Icon, Link, Card, Typography } from "@material-ui/core"
import { LocaleContext } from "../contexts/LocaleContext"

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(2),
  },
  icon: {
    display: "block",
  },
  line: {
    fontSize: 18,
    display: "block",
  },
  phone: {
    fontSize: 22,
    display: "block",
    color: theme.palette.turistBlue.main,
    marginBottom: 15,
  },
  schedule: {
    display: "block",
    fontSize: 10,
  },
}))

const NeedHelpBlock = () => {
  const lang = React.useContext(LocaleContext)
  const i18n = lang.i18n[lang.locale]
  const classes = useStyles()

  return (
    <Card className={classes.root} variant="outlined" square>
      <Typography component="span" className={classes.icon}>
        <Icon className="icon_set_1_icon-57" style={{ fontSize: 40 }} />
      </Typography>
      <Typography
        component="span"
        className={classes.line}
        dangerouslySetInnerHTML={{
          __html: i18n.bookNow,
        }}
      />

      <Typography
        component={Link}
        href={`tel:${i18n.phone}`}
        className={classes.phone}
      >
        {i18n.phone}
      </Typography>

      <Typography component="small" className={classes.schedule}>
        {i18n.schedule}
      </Typography>
    </Card>
  )
}

export default NeedHelpBlock

NeedHelpBlock.propTypes = {}
